import { Expose, Type } from 'class-transformer'

import { Batch } from './Batch'
import { Product } from './Product'
import { FreightOrder } from './FreightOrder'
import { Sku } from './Sku'

export class FreightOrderUnit {
  get guid() {
    return this.sku?.guid
  }

  @Type(() => FreightOrder)
  order?: FreightOrder

  @Type(() => Product)
  product?: Product

  @Type(() => Sku)
  sku?: Sku

  @Type(() => Batch)
  batch?: Batch

  @Expose({ name: 'num_units' })
  numUnits?: string

  @Expose({ name: 'num_picked' })
  numPicked?: string

  @Expose({ name: 'num_fulfilled' })
  numFulfilled?: string

  status?: string
}
